import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default {
  sendVerificationCode(email, powChallenge, powNonce) {
    return apiClient.post(API_ENDPOINTS.USER.SEND_VERIFICATION_CODE, {
      email,
      pow_challenge: powChallenge,
      pow_nonce: powNonce
    });
  },
  
  register(userData) {
    return apiClient.post(API_ENDPOINTS.USER.REGISTER, userData);
  },
  
  login(credentials) {
    return apiClient.post(API_ENDPOINTS.USER.LOGIN, credentials);
  }
};